import {
    ApolloClient,
    createHttpLink,
    gql,
    InMemoryCache,
} from '@apollo/client';
import { persistCache, SessionStorageWrapper } from 'apollo3-cache-persist';
import { setContext } from '@apollo/client/link/context';


import keycloak from '../keycloak/keycloak';
import { checkRefreshToken } from '../keycloak/keycloakUtils';

class ApolloServiceClient {
    /* eslint-disable class-methods-use-this */
    async initApolloClient() {
        const httpLink = createHttpLink({
            uri: process.env.NODE_ENV === 'development'
                ? "https://mclass-enrollment.aws.wgen.net/graphql"
                : "https://mclass-enrollment.mclass.amplify.com/graphql",
        });
        const authLink = setContext(({ headers }) =>
            checkRefreshToken().then(() => Promise.resolve({
                headers: {
                    ...headers,
                    authorization: `Bearer ${keycloak.token}`,
                },
            }))
        );

        const cache = new InMemoryCache();
        await persistCache({
            cache,
            storage: new SessionStorageWrapper(window.sessionStorage),
        });

        return new ApolloClient({
            link: authLink.concat(httpLink),
            cache,
        });
    }

    async getClient() {
        if (!this.client) {
            this.client = await this.initApolloClient();
        }
        return this.client;
    }

}

export default new ApolloServiceClient();

export const GET_STAFF_CONFIG = gql`
query GetStaffConfig {
    getStaffConfig {
        licenses
    }
}
`;

export const GET_ACCESSIBILITY_CONFIG = gql`
query GetAccessibilityQuery($studentUids: String!) {
    getApplicationConfigResolvers_v2(studentUids: $studentUids){
      accessibilityConfig {
        studentUid
        config {
          zoom,
          isMazeUntimed
          isCaptionsEnabled
          isAnimationVisualReduced
        }
        config_bk
      }
    }
}
`;

export const SET_ACCESSIBILITY_CONFIG = gql`
    mutation SetAccessibilityConfig(
        $configBK: String = null,
        $fontSizeScaleValue: Float!,
        $isCaptionsEnabled: Boolean!,
        $isAnimationVisualReduced: Boolean!,
        $studentUid: String!) {
        postApplicationConfigResolvers_v2(
            config: {
                accessibility: {
                    zoom: $fontSizeScaleValue
                    isCaptionsEnabled: $isCaptionsEnabled
                    isAnimationVisualReduced: $isAnimationVisualReduced
                }
            }
            configBK: $configBK
            studentUid: $studentUid
        ) {
            accessibility_bk
        }
    }
`;

export const GET_INSTITUTION_INFO = gql`
query GetInstitutionInfo($instId: String!) {
    getInstitutionInfo_v2(instId: $instId) {
        windowDates {
            fourthWindowLabel
        }
    }
}
`;
